<template lang="html">
	<nav
		:class="[
			'fixed top-0 left-0 right-0 z-50 transition-all duration-300',
			scrolled ? 'bg-white shadow-md py-2' : 'bg-white py-2',
		]"
	>
		<div
			class="flex items-center justify-between max-w-screen-xl px-4 mx-auto lg:px-6"
		>
			<a href="https://nexus.ke" class="flex items-center group">
				<img
					src="/assets/Logo/nexus.svg"
					alt="Nexus Logo"
					class="w-32 h-auto object-contain transition-all duration-300"
				/>
			</a>

			<div class="hidden space-x-2 lg:flex">
				<a
					href="#"
					class="px-5 py-2.5 font-medium transition-all duration-200 rounded-lg text-primary bg-primary/5 hover:bg-primary/10"
					>Home</a
				>
				<a
					href="/about-us"
					class="px-5 py-2.5 font-medium transition-all duration-200 rounded-lg text-textPrimary hover:bg-surface"
					>About Us</a
				>
				<a
					href="/contactus"
					class="px-5 py-2.5 font-medium transition-all duration-200 rounded-lg text-textPrimary hover:bg-surface"
					>Contact Us</a
				>
				<a
					href="/terms"
					class="px-5 py-2.5 font-medium transition-all duration-200 rounded-lg text-textPrimary hover:bg-surface"
					>Terms</a
				>
			</div>

			<button
				@click="$emit('toggle-mobile-menu')"
				class="p-2.5 transition-all duration-200 rounded-lg lg:hidden text-textPrimary hover:bg-surface active:bg-surface"
			>
				<svg
					v-if="!mobileMenuOpen"
					class="w-6 h-6"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M4 6h16M4 12h16M4 18h16"
					></path>
				</svg>
				<svg
					v-else
					class="w-6 h-6"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M6 18L18 6M6 6l12 12"
					></path>
				</svg>
			</button>
		</div>

		<div
			v-if="mobileMenuOpen"
			class="lg:hidden bg-white border-t border-border animate-slideDown"
		>
			<div class="px-4 py-4 space-y-2">
				<a
					href="#"
					class="block px-5 py-3 font-medium transition-all duration-200 rounded-lg text-primary bg-primary/5 hover:bg-primary/10"
					>Home</a
				>
				<a
					href="/about-us"
					class="block px-5 py-3 font-medium transition-all duration-200 rounded-lg text-textPrimary hover:bg-surface"
					>About Us</a
				>
				<a
					href="/contactus"
					class="block px-5 py-3 font-medium transition-all duration-200 rounded-lg text-textPrimary hover:bg-surface"
					>Contact Us</a
				>
			</div>
		</div>
	</nav>
</template>

<script>
export default {
	name: 'Navigation',
	props: {
		scrolled: Boolean,
		mobileMenuOpen: Boolean,
	},
};
</script>

<style scoped>
@keyframes slideDown {
	from {
		opacity: 0;
		transform: translateY(-10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.animate-slideDown {
	animation: slideDown 0.3s ease-out;
}
</style>
